<div *ngIf="hasSafeIframeUrl">
  <iframe style="visibility:hidden !important;" [src]="safeIframeUrl" height="1" width="1" frameborder="0"></iframe>
</div>
<div *ngIf="hasSafeJavaScriptUrl">
  <script type="text/javascript" [src]="safeJavaScriptUrl"></script>
</div>
<div *ngIf="hasSafeImagePixelUrl">
  <img style="visibility:hidden !important;" [src]="safeImagePixelUrl" height="1" alt="samplecube" width="1" border="0">
</div>
